module.exports = __webpack_public_path__ + "img/access_time_24px.56c21d08.svg";